import e from "../_virtual/_rolldown_dynamic_import_helper.js";
//#region src/i18n/loaders.ts
var t = async (t, n) => e(/* #__PURE__ */ Object.assign({
	"../locales/ar/common.json": () => import("../locales/ar/common.json.js"),
	"../locales/cs/common.json": () => import("../locales/cs/common.json.js"),
	"../locales/da/common.json": () => import("../locales/da/common.json.js"),
	"../locales/de/common.json": () => import("../locales/de/common.json.js"),
	"../locales/el/common.json": () => import("../locales/el/common.json.js"),
	"../locales/en/common.json": () => import("../locales/en/common.json.js"),
	"../locales/es/common.json": () => import("../locales/es/common.json.js"),
	"../locales/fr/common.json": () => import("../locales/fr/common.json.js"),
	"../locales/hi/common.json": () => import("../locales/hi/common.json.js"),
	"../locales/hu/common.json": () => import("../locales/hu/common.json.js"),
	"../locales/id/common.json": () => import("../locales/id/common.json.js"),
	"../locales/it/common.json": () => import("../locales/it/common.json.js"),
	"../locales/ja/common.json": () => import("../locales/ja/common.json.js"),
	"../locales/nl/common.json": () => import("../locales/nl/common.json.js"),
	"../locales/no/common.json": () => import("../locales/no/common.json.js"),
	"../locales/pl/common.json": () => import("../locales/pl/common.json.js"),
	"../locales/pt/common.json": () => import("../locales/pt/common.json.js"),
	"../locales/ro/common.json": () => import("../locales/ro/common.json.js"),
	"../locales/ru/common.json": () => import("../locales/ru/common.json.js"),
	"../locales/sk/common.json": () => import("../locales/sk/common.json.js"),
	"../locales/sl/common.json": () => import("../locales/sl/common.json.js"),
	"../locales/sq/common.json": () => import("../locales/sq/common.json.js"),
	"../locales/sr/common.json": () => import("../locales/sr/common.json.js"),
	"../locales/sv/common.json": () => import("../locales/sv/common.json.js"),
	"../locales/th/common.json": () => import("../locales/th/common.json.js"),
	"../locales/tr/common.json": () => import("../locales/tr/common.json.js"),
	"../locales/uk/common.json": () => import("../locales/uk/common.json.js"),
	"../locales/zh/common.json": () => import("../locales/zh/common.json.js")
}), `../locales/${t}/${n}.json`, 4).then((e) => e.default);
//#endregion
export { t as loadLangBundle };
